import React, { Component } from "react";
import PropTypes from "prop-types";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { Grid, TextField } from "@mui/material";
import { Navigate, Link, useParams, useNavigate, useLocation } from "react-router-dom";

class UpdateBanner extends Component {
  state = {
    loading: false,
    notification: false,
    message: "",
    redirect: false,

    banner_title: "",
    redirect_url: "",
    banner_image: null,
    current_image_url: "",

    fetched: false,
  };

  componentDidMount() {
    // Support both v5 (match.params.id) and v6 (params.id injected via HOC)
    const id =
      this.props?.match?.params?.id ||
      this.props?.params?.id ||
      (this.props?.params && this.props.params.id) ||
      null;

    if (!id) {
      this.setState({ redirect: true });
      return;
    }

    this.fetchBanner(id);
  }

  fetchBanner = (id) => {
    this.setState({ loading: true });
    try {
      const getUrl = Constants.getUrls.getAllBanners;
      const url = getUrl.includes(":id") ? getUrl.replace(":id", id) : `${getUrl}/${id}`;

      axios
        .get(url)
        .then((resp) => {
          const banner = resp?.data?.data || resp?.data || {};
          this.setState({
            banner_title: banner.banner_title || "",
            redirect_url: banner.redirect_url || "",
            current_image_url: banner.banner_image || banner.image || "",
            loading: false,
            fetched: true,
          });
        })
        .catch((err) => {
          const msg = err?.response?.data?.message || err.message || "Failed to fetch banner";
          this.setState({
            loading: false,
            notification: true,
            message: msg,
          });
          setTimeout(() => this.setState({ notification: false, message: "" }), 3500);
        });
    } catch (error) {
      this.setState({
        loading: false,
        notification: true,
        message: "Something went wrong while fetching",
      });
      setTimeout(() => this.setState({ notification: false, message: "" }), 3500);
    }
  };

  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFile = (e) => {
    const file = e.target.files[0];
    this.setState({ banner_image: file });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const id =
      this.props?.match?.params?.id ||
      this.props?.params?.id ||
      (this.props?.params && this.props.params.id) ||
      null;

    if (!id) {
      this.setState({ notification: true, message: "Missing banner id" });
      setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      return;
    }

    this.setState({ loading: true });

    const form = new FormData();
    form.append("banner_title", this.state.banner_title);
    form.append("redirect_url", this.state.redirect_url);

    if (this.state.banner_image) {
      form.append("banner_image", this.state.banner_image);
    }

    if (init() !== "success") {
      this.setState({
        loading: false,
        notification: true,
        message: "Auth token missing or invalid",
      });
      setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      return;
    }

    const putUrlTemplate = Constants.putUrls.updateBanner;
    const putUrl = putUrlTemplate.includes(":id")
      ? putUrlTemplate.replace(":id", id)
      : `${putUrlTemplate}/${id}`;

    axios
      .put(putUrl, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((resp) => {
        this.setState({
          loading: false,
          notification: true,
          message: resp?.data?.message || "Banner updated successfully",
          redirect: true,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err.message || "Update failed";
        this.setState({
          loading: false,
          notification: true,
          message: msg,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 4000);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/banner" replace={true} />;
    }

    // if (!this.state.fetched) {
    //   return (
    //     <DashboardLayout>
    //       <DashboardNavbar />
    //       <MDBox pt={6} pb={3}>
    //         <MDTypography>Loading...</MDTypography>
    //       </MDBox>
    //     </DashboardLayout>
    //   );
    // }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Update Banner
            </MDTypography>
          </MDBox>

          <MDBox py={3} px={2}>
            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <TextField
                    type="text"
                    label="Banner Title"
                    name="banner_title"
                    value={this.state.banner_title}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                <Grid item sm={6}>
                  <TextField
                    type="text"
                    label="Redirect URL"
                    name="redirect_url"
                    value={this.state.redirect_url}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                <Grid item sm={6}>
                  <TextField
                    type="file"
                    name="banner_image"
                    onChange={this.handleFile}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>

                <Grid item sm={12}>
                  {this.state.current_image_url && (
                    <div style={{ marginTop: 10 }}>
                      <MDTypography variant="caption">Current Image:</MDTypography>
                      <div style={{ marginTop: 8 }}>
                        <img
                          src={
                            (this.state.current_image_url || "").startsWith("/uploads")
                              ? Constants.imageDomain + this.state.current_image_url
                              : this.state.current_image_url
                          }
                          alt="banner"
                          style={{
                            maxWidth: "100%",
                            maxHeight: 250,
                            objectFit: "contain",
                            borderRadius: 6,
                          }}
                        />
                      </div>
                    </div>
                  )}
                </Grid>

                <Grid item sm={12}>
                  <MDButton variant="contained" color="info" size="small" type="submit">
                    {this.state.loading ? "Updating..." : "Update Banner"}
                  </MDButton>
                  <Link to="/banner" style={{ textDecoration: "none", marginLeft: 12 }}>
                    <MDButton variant="outlined" color="info" size="small">
                      Cancel
                    </MDButton>
                  </Link>
                </Grid>
              </Grid>
            </form>
          </MDBox>

          <MDSnackbar
            color="success"
            icon="notifications"
            title="Banners"
            content={this.state.message}
            dateTime="Just now"
            open={this.state.notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}

/**
 * propTypes & defaultProps to satisfy ESLint react/prop-types
 * - match is for react-router v5
 * - params is for react-router v6 (injected via HOC below)
 */
UpdateBanner.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  params: PropTypes.shape({
    id: PropTypes.string,
  }),
};

UpdateBanner.defaultProps = {
  match: undefined,
  params: undefined,
};

/**
 * withRouterParams HOC (for react-router v6)
 * Injects params, navigate, location so class component can use them via props.params
 */
function withRouterParams(Component) {
  return function (props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} params={params} navigate={navigate} location={location} />;
  };
}

// Export wrapped component to support react-router v6. For v5 usage (if you mount via <Route component={UpdateBanner} />),
// either import the wrapped component (works fine) or use the original class directly.
export default withRouterParams(UpdateBanner);
